import React, { useState } from 'react';
import Navbar from '../components/navbar';
import '../styles/components/profile-page.scss';
import classNames from 'classnames';
import CredentialProxy from '../components/menu/proxies/credential-proxy';

const ProxyPage = () => {
  const [tabActive, setTabActive] = useState('proxy');

  const sideBarElemCardIsActiveClass = classNames('profile-page-sidebar-elem', {
    'profile-page-sidebar-elem--active': tabActive === 'proxy'
  });

  return (
    <div className='profile-page'>
      <Navbar />

      <div className='under-navbar-content'>
        <div className='profile-page__container'>
          <div className='profile-page-sidebar'>
            <div className='profile-page-sidebar__title profile-page__headline-title'>Меню</div>
            <div className='profile-page-sidebar-list'>
              <div className={sideBarElemCardIsActiveClass} onClick={() => setTabActive('card')}>
                <div className='profile-page-sidebar-elem__icon'>
                  <svg
                    width='12'
                    height='14'
                    viewBox='0 0 12 14'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M8.94946 2.70801C8.53812 1.52001 7.40946 0.666681 6.08146 0.666681C4.40612 0.660014 3.04212 2.01201 3.03479 3.68735V3.70068V5.13201'
                      stroke='#828282'
                      strokeWidth='1.2'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    />
                    <path
                      fillRule='evenodd'
                      clipRule='evenodd'
                      d='M8.622 13.0003H3.528C2.132 13.0003 1 11.8683 1 10.4716V7.61294C1 6.21627 2.132 5.08427 3.528 5.08427H8.622C10.018 5.08427 11.15 6.21627 11.15 7.61294V10.4716C11.15 11.8683 10.018 13.0003 8.622 13.0003Z'
                      stroke='#828282'
                      strokeWidth='1.2'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    />
                    <path
                      d='M6.07503 8.30174V9.78308'
                      stroke='#828282'
                      strokeWidth='1.2'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    />
                  </svg>
                </div>
                <div className='profile-page-sidebar-elem__text'>Прокси</div>
              </div>
            </div>
          </div>
          <div className='profile-page-info'>
            {tabActive === 'proxy' && (
              <CredentialProxy />
            )}
          </div>
        </div>
      </div>
    </div>
  )
    ;
};

export default ProxyPage;
